import React, { useEffect, useRef, useState } from "react";
import { USE_VISION_MISSION_SCROLL_WITH_EVENT } from "../../config";
import IntroduceSection1 from "./IntroduceSection1";
import IntroduceSection2 from "./IntroduceSection2";
import IntroduceSection3 from "./IntroduceSection3";
import IntroduceSection4 from "./IntroduceSection4";
import IntroduceSection5 from "./IntroduceSection5";
import IntroduceSection6 from "./IntroduceSection6";
import IntroduceSection7 from "./IntroduceSection7";
import IntroduceSection8 from "./IntroduceSection8";
import FooterSectionMobile from "../base/FooterSectionMobile";
import FooterSection from "../base/FooterSection";
import { useDeviceType } from "../../hooks/useDeviceType";
import { useHideMenu } from "../../hooks/useHideMenu";
import menuStore from '../../store/MenuStore';
import { useScrollMenuHandler } from "../../hooks/useScrollMenuHandler";

const MemoizedIntroduceSection6 = React.memo(IntroduceSection6);
const MemoizedIntroduceSection7 = React.memo(IntroduceSection7);

const IntroduceMainPage: React.FC = () => {
  const { isMobile } = useDeviceType();

  const sectionRef = useRef<HTMLDivElement>(null);
  const sectionRef2 = useRef<HTMLDivElement>(null);
  const sectionRef3 = useRef<HTMLDivElement>(null);
  const sectionRef4 = useRef<HTMLDivElement>(null);
  const sectionRef5 = useRef<HTMLDivElement>(null);
  const sectionRef6 = useRef<HTMLDivElement>(null);
  const sectionRef7 = useRef<HTMLDivElement>(null);
  const sectionRef8 = useRef<HTMLDivElement>(null);
  const sectionRef9 = useRef<HTMLDivElement>(null);

  const [showAction1, setShowAction1] = useState(true);
  const [showAction2, setShowAction2] = useState(true);

  const fullpageRef = useRef<HTMLDivElement>(null);
  const [pageIndex, setPageIndex] = useState(0);

  useScrollMenuHandler();
  useHideMenu();

  useEffect(() => {
    menuStore.hide();
    menuStore.setBackgroundColor('transparent');
    menuStore.setDarkMode(false);
    const timer = setTimeout(() => {
      menuStore.attach();
      menuStore.show();
    }, 3000);

    return () => clearTimeout(timer); // cleanup
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!fullpageRef.current) return;
      const rect = fullpageRef.current.getBoundingClientRect();
      const overScrollHeight = (sectionRef4.current?.getBoundingClientRect().height ?? 0) +
        (sectionRef5.current?.getBoundingClientRect().height ?? 0) +
        (sectionRef6.current?.getBoundingClientRect().height ?? 0) +
        (sectionRef7.current?.getBoundingClientRect().height ?? 0) +
        (sectionRef8.current?.getBoundingClientRect().height ?? 0) +
        (sectionRef9.current?.getBoundingClientRect().height ?? 0);
      const height = rect.height - overScrollHeight - window.innerHeight; // sticky 컨테이너 전체 높이
      const progress = Math.min(Math.max(0, -rect.top), height); // 0~height
      const idx = Math.floor((progress / height) * 5); // 0~4
      if (idx >= 0 && idx <= 4) {
        setPageIndex(idx);
      }
      if (rect.top <= 0 && rect.top >= -(window.innerHeight * 5)) {
        menuStore.hide();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const totalPages = 5;
  const overScrollHeight = (sectionRef4.current?.getBoundingClientRect().height ?? 0) +
    (sectionRef5.current?.getBoundingClientRect().height ?? 0) +
    (sectionRef6.current?.getBoundingClientRect().height ?? 0) +
    (sectionRef7.current?.getBoundingClientRect().height ?? 0) +
    (sectionRef8.current?.getBoundingClientRect().height ?? 0) +
    (sectionRef9.current?.getBoundingClientRect().height ?? 0);
  const stickyHeight = window.innerHeight * totalPages + overScrollHeight;

  return (
    <div style={{ position: "relative", backgroundColor: 'red', boxSizing: 'border-box', margin: '0px', padding: '0px' }}>
      {/* Section 1 */}
      <div ref={sectionRef} style={{ width: '100%', overflowX: 'hidden' }}>
        <IntroduceSection1 isInView={showAction1} />
      </div>

      <div ref={sectionRef2} style={{ width: '100%', overflowX: 'hidden' }}>
        <IntroduceSection2 isInView={showAction2} />
      </div>

      {/* Section 2 (뷰포트에 고정) */}
      <div ref={fullpageRef} style={{ position: "relative", height: `${stickyHeight}px` }}>
        <section
          style={{
            position: "sticky",
            top: 0,
            height: `100vh`,
            background: "lightblue",
            zIndex: 2,
            width: '100%'
          }}
        >
          <div style={{ width: '100%', height: '100vh', overflowX: 'hidden', opacity: USE_VISION_MISSION_SCROLL_WITH_EVENT ? 0 : 1 }}>
            <IntroduceSection3 pageIndex={pageIndex} progress={0.000001}/>
          </div>
        </section>
      </div>


      <div ref={sectionRef4} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5, marginTop: `-${overScrollHeight}px` }}>
        <IntroduceSection4 />
      </div>

      <div ref={sectionRef5} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5 }}>
        <IntroduceSection5 />
      </div>

      <div ref={sectionRef6} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5 }}>
        <MemoizedIntroduceSection6 />
      </div>

      <div ref={sectionRef7} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5 }}>
        <MemoizedIntroduceSection7 />
      </div>

      <div ref={sectionRef8} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5 }}>
        <IntroduceSection8 />
      </div>

      <div ref={sectionRef9} style={{ width: '100%', overflowX: 'hidden', position: "relative", zIndex: 5 }}>
        {isMobile ? <FooterSectionMobile /> : <FooterSection />}
      </div>
    </div>
  );
};

export default IntroduceMainPage;
